// packages/eden-table/src/components/SelfSelect/Context.jsx
import { createContext } from "react";
var SelfSelectContext = createContext({
  columnsRef: {},
  renderRowChildren: (children) => children
});
var Context_default = SelfSelectContext;
export {
  Context_default as default
};
